// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1ttDj","footer":"ReportModalFilter_footer__65Dpe"};